import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger.js'
import {Draggable} from 'gsap/Draggable'
import { startLocoScroll, updateLocoScroll } from '../locomotive-scroll'
import { breakpointUp } from '../helpers/breakpoints'

gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(Draggable)


export function setUpFirstBlock(locoScroll){


  $('.js-explore').click(function(){
        let scrollTo = window.innerHeight // $('#content-block').offset().top + 10
        locoScroll.scrollTo(scrollTo, { duration: 800, callback: updateLocoScroll })
    })

  if (window.innerWidth > 1200) {
    locoScroll.on('scroll', function (e) {
      let scrolled = Math.ceil(e.scroll.y)
      if (scrolled > 100){
        $('.js-hero-block').addClass('scrolled')
      } else {
        $('.js-hero-block').removeClass('scrolled')
      }
    })
  }


}

export function loadHeroBlock(){
    let video = document.querySelector('.js-hero-video')
    let onVideoBlock = '.js-hero-on-video'
    let loadHero = gsap.timeline({})
      .set(onVideoBlock + ' .on-video-content', {opacity: 1})
      .from(onVideoBlock + ' h1', {top: '2rem', opacity: 0, duration: 0.4})
      .to(onVideoBlock, {background: 'rgba(0, 0, 0, 0.35)', duration: 1})
      .from(onVideoBlock + ' h1', {color: '#EACEBF', duration: 0.4})
      .from(onVideoBlock + ' .explore-c', {bottom: '0', opacity: 0, duration: 0.4}, '-=0.8')
    video.play()

    if ($('body').hasClass('is-ios')){
      video.setAttribute('controls', '')
    }
}

$('.js-explore').hover(
  function (){
      $('.hero-block').addClass('explore-hovered')
  },
  function (){
    $('.hero-block').removeClass('explore-hovered')
  },
)
